import React from "react";
import classnames from "classnames";
import { useImageStore } from "@store/image";
import {
    CONFIGURATOR_MODE,
} from "@constants";
import {
    useConfiguratorMode,
    useActiveProductData,
    useActiveUniqueMaterial
} from "@store/pdp";
import "./pdp-download-button.scss";
import { useTranslation } from "react-i18next";
import { log } from "@assets/js/utils";

const PDPDownloadButton = ({ isRendering = true, customImageUrl }) => {
    const { t } = useTranslation();
    const texts = {
        saveImage: t("FritzHansen_Project_ConsumersAndProfessionals_Portfolio_DownloadImage")
    };
    const [imageUrl] = useImageStore();
    const [configuratorMode] = useConfiguratorMode();
    const [activeProductData] = useActiveProductData();
    const [activeUniqueMaterial] = useActiveUniqueMaterial();

    const getImageId = (localImageUrl) => {
        if (!isRendering) {
            if (activeUniqueMaterial?.id) {
                return process.env.REACT_APP_ROOTAPI + "downloadapi/downloaduniquematerial/" + activeUniqueMaterial.id;
            }
            var splittedImageUrl = localImageUrl?.split("/");
            var lengthOfArray = splittedImageUrl?.length;
            if (splittedImageUrl && lengthOfArray) {
                var imageId = splittedImageUrl[lengthOfArray - 1];
                return process.env.REACT_APP_ROOTAPI + "downloadapi/download/" + imageId.split(".")[0] + "/false/0";
            }
            return "";
        } else {
            var splittedImageUrl = imageUrl?.split("/");
            var lengthOfArray = splittedImageUrl?.length;
            if (splittedImageUrl && lengthOfArray) {
                var imageId = splittedImageUrl[lengthOfArray - 1];
                if (imageId) {
                    var skuAndAngle = imageId.split(".");
                    if (skuAndAngle.length > 1) {
                        var sku = skuAndAngle[0];
                        var bgcolor = imageId.split("bgcolor=");
                        if (bgcolor) {
                            var color = bgcolor[bgcolor.length - 1];
                            return process.env.REACT_APP_ROOTAPI + "downloadapi/download/" + sku + "/true/" + color;
                        }
                    }
                }
            }
            return "";
        }
    }

    const downloadImagesClasses = classnames({
        "pdp-download-images": true,
        "is-styled-image": !isRendering
    });

    return (
        <div>
            {(customImageUrl || activeProductData.imageUrl || imageUrl || activeUniqueMaterial?.id) && (
                <a className={downloadImagesClasses} href={getImageId(customImageUrl || isRendering ? imageUrl : activeProductData.imageUrl)}>
                    <span>{texts.saveImage}</span>
                </a>
            )}
        </div>
    );
};
export default PDPDownloadButton;